<template>
    <div class="networks-page scrollable">
        <div class="page-header">
            <h1>Networks</h1>
            <el-breadcrumb separator="/">
                <el-breadcrumb-item :to="{ path: '/' }">
                    <i class="mdi mdi-home-outline"></i>
                </el-breadcrumb-item>
                <el-breadcrumb-item>Networks</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="top-bar">
            <div class="count-user">
              <el-table :data="Object.values(networksStatistic)" style="width: 100%;" >
                <el-table-column prop="Network">
                  <template slot="header" slot-scope="scope">
                    Group
                  </template>
                  <template slot-scope="scope">
                    {{ scope.row.group }}
                  </template>
                </el-table-column>
                <el-table-column prop="active">
                  <template slot="header" slot-scope="scope">
                    Active
                  </template>
                  <template slot-scope="scope">
                    {{ scope.row.active }}
                  </template>
                </el-table-column>
                <el-table-column prop="inactive">
                  <template slot="header" slot-scope="scope">
                    Inactive
                  </template>
                  <template slot-scope="scope">
                    {{ scope.row.inactive }}
                  </template>
                </el-table-column>
                <el-table-column prop="inactive">
                  <template slot="header" slot-scope="scope">
                    New
                  </template>
                  <template slot-scope="scope">
                    {{ scope.row.new }}
                  </template>
                </el-table-column>
                <el-table-column prop="inactive">
                  <template slot="header" slot-scope="scope">
                    Can't Implement
                  </template>
                  <template slot-scope="scope">
                    {{ scope.row.cannot_implement }}
                  </template>
                </el-table-column>
                <el-table-column prop="inactive">
                  <template slot="header" slot-scope="scope">
                    Pending
                  </template>
                  <template slot-scope="scope">
                    {{ (scope.row && scope.row.pending) ? scope.row.pending : 0}}
                  </template>
                </el-table-column>
                <el-table-column prop="inactive">
                  <template slot="header" slot-scope="scope">
                    Free On
                  </template>
                  <template slot-scope="scope">
                    {{ scope.row.free }}
                  </template>
                </el-table-column>
              </el-table>
            </div>
            <div class="filter-user">
                <button type="button"
                        class="el-button el-button--primary"
                @click="goToAddNetwork">
                    <span>Add new</span>
                </button>
            </div>
        </div>
        <div class="top-bar">
            <div class="count-networks">
                Show
                <el-select
                        v-model="countNets"
                        @change="changeCount"
                        placeholder=" "
                >
                    <el-option
                            v-for="item in countNetworksOptions"
                            :key="item.value"
                            :label="item.value"
                            :value="item.value"
                    >
                    </el-option>
                </el-select>
                entries
            </div>
            <div class="filter-user">
                <el-input
                        @change="searchNetworks"
                        placeholder="Search networks"
                        v-model="filterNets"
                        prefix-icon="el-icon-search"
                ></el-input>
            </div>
        </div>
      <el-tabs type="border-card" @tab-click="updateNetworkList" v-model="selectedTab">
        <el-tab-pane label="All" group="" name="All">
          <network-table-list page-label="all" :filter-props="filterBlock['all']" @updateContent="updateFilter('all',$event)"  />
        </el-tab-pane>
        <el-tab-pane label="Dating" group="dating" name="Dating">
          <network-table-list page-label="dating" :filter-props="filterBlock['dating']" @updateContent="updateFilter('dating',$event)" />
        </el-tab-pane>
        <el-tab-pane label="Social" group="social" name="Social">
          <network-table-list page-label="social" :filter-props="filterBlock['social']" @updateContent="updateFilter('social',$event)" />
        </el-tab-pane>
        <el-tab-pane label="XXX" group="xxx" name="XXX">
          <network-table-list page-label="xxx" :filter-props="filterBlock['xxx']" @updateContent="updateFilter('xxx', $event)"/>
        </el-tab-pane>
        <el-tab-pane label="Cams" group="live_cams" name="Cams">
          <network-table-list page-label="live_cams" :filter-props="filterBlock['live_cams']" @updateContent="updateFilter('live_cams',$event)" />
        </el-tab-pane>

      </el-tabs>
    </div>
</template>

<script>
  import NetworkTableList from "../../../components/Networks/NetworkTableList";
  import {mapGetters} from "vuex";

  export default {
    name: 'NetworksPage',
    components: {
      NetworkTableList,
    },
    data () {
      return {
        filterNets: '',
        filterBlock:{},
        socialFilter:{},
        group:'',
        countNetworksOptions: [
          {value: 10},
          {value: 25},
          {value: 50},
          {value: 100},
        ],
        chosenPage: 1,
      }
    },
    computed: {
      ...mapGetters({
        networksStatistic: 'networks/getNetworksStatistic',
        selectedTabFromVuex: 'networkNetworksFilter/getSelectedTab',
        countNetsFromVuex: 'networkNetworksFilter/getCountNets',
      }),
      selectedTab: {
          get() {
              return this.selectedTabFromVuex;
          },
          set(value) {
              this.$store.dispatch('networkNetworksFilter/updateSelectedTab', value);
          },
      },
      countNets: {
          get() {
              return this.countNetsFromVuex;
          },
          set(value) {
              this.$store.dispatch('networkNetworksFilter/updateCountNets', value);
          },
      },             
    },
    mounted () {
      let params='';
      if(this.pageLabel) {
        params = `group=${this.pageLabel}`
      }
      this.$store.dispatch('networks/getNetworks', params),
      this.$store.dispatch('networks/getNetworksStatistic'),
      this.$store.dispatch('networks/getNetworksStatuses')
    },
    watch:{
      filterNets(){
        this.updateNetworkList()
      }           
    },      
    methods: {

      updateFilter(label, value){
        this.filterBlock[label]=value;
      },
      upperFirst(str) {
        return str[0].toUpperCase() + str.slice(1)
      },
      changeCount(e) {
        this.countNets = e
        this.updateNetworkList()
      },
      searchNetworks(e) {
        this.filterNets = e
        this.updateNetworkList()
      },
      updateNetworkList(tab, tabName, event) {
        this.$store.dispatch('networkNetworksFilter/updateChosenPage', 1);

        this.group = tab !=undefined ? tab.$attrs.group :this.group;
        let params = 'sort='
        if (this.sortBy) {
          for (let itm in this.sortBy) {
            if (this.sortBy[itm] === 1) {
              params = `${params}${itm},`
            } else if (this.sortBy[itm] === -1) {
              params = `${params}-${itm},`
            }
          }
        }

        if (params === 'sort=') {
          params = ''
        }

        params = `${params}&page=${this.chosenPage}`
        if (this.countNets) {
          params = `${params}&per_page=${this.countNets}`
        }
        if (this.filterNets.length) {
          params = `${params}&filter=${this.filterNets}`
        }
        if(this.group) {
          params = `${params}&group=${this.group}`
        }

        if (this.filterBlock.hasOwnProperty(this.group) && Object.keys(this.filterBlock[this.group]).length) {
          Object.entries(this.filterBlock[this.group]).forEach(([key, value]) => {
            if(value.length === 0){
              return;
            }
            params = `${params}&${key}=`+JSON.stringify(value)
          });
        }

        this.$store.dispatch('networks/getNetworks', params)
      },
      goToAddNetwork() {
        this.$router.push({name: 'network-create'})
      },
    }

  }
</script>

<style scoped lang="scss">
    .networks-page {
          overflow-x: hidden;
    }
    th {
        .cell {
            .pointer {
                cursor: pointer;
            }
        }
    }

    .count-networks {
        width: 170px;
        margin-bottom: 25px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        & > div {
            margin: 0 5px;
        }
    }

    .filter-user {

    }
</style>